import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EditDropdown from '@components/EditDropdown';
import moment from 'moment';
import Rating from '@components/@core/Rating';
import AppActions from '~/actions/app';
import DevelopActions from '~/actions/develop';
import ManageActions from '~/actions/manage';
import { LibraryScoreCardsTabs, ScorecardReportMenu } from '~/services/config';
import { removeAssign } from '~/services/util';

const ListHeader = () => (
    <div className="vdmm-cp-header d-flex desktop-flex">
        <div className="d-flex-2 me-3 me-md-0">
            <span className="dsl-m12">Type</span>
        </div>
        <div className="d-flex-5">
            <span className="dsl-m12">Scorecard</span>
        </div>
        <div className="d-flex-2">
            <span className="dsl-m12">Goals</span>
        </div>
        <div className="d-flex-3 text-start">
            <span className="dsl-m12">Assigned</span>
        </div>
        <div className="d-flex-4">
            <span className="dsl-m12">Recent score</span>
        </div>
        <div className="d-flex-2">
            <span className="dsl-m12">Status updated</span>
        </div>
        <div className="d-flex-1"></div>
    </div>
);

export const ScorecardItem = ({ data, role, index, onDetail, onSelectMenu }) => {
    const performanceReviews = useSelector((state) => state.manage.companyPerformanceReviews);
    const performance = performanceReviews?.users[0]?.performance;
    const dispatch = useDispatch();
    const toggleModal = (e) => dispatch(AppActions.modalRequest(e));
    const dotsMenu = ScorecardReportMenu[role];
    const options = removeAssign(dotsMenu, data?.published || 0);
    const changeHandler = (event, card) => {
        switch (event) {
            case 'detail view': {
                onDetail(card);

                break;
            }
            case 'assign': {
                const payload = {
                    type: 'Assign ScoreCard',
                    data: { before: { modules: [card] }, after: [] },
                };
                toggleModal(payload);

                break;
            }
        }
    };

    const dateKeys = data ? Object.keys(data?.data)?.filter((key) => moment(key, 'YYYY-MM-DD', true).isValid()) : [];
    const momentKeys = dateKeys?.map((key) => moment(key, 'YYYY-MM-DD'));
    const latestDate = momentKeys.length > 0 ? moment.max(momentKeys).format('YYYY-MM-DD') : null;
    const value = data?.data[latestDate];

    return (
        <div className="card-hover d-flex ssm-column ai-center ai-sm-unset ssm-start border-ssm-bottom" onClick={() => onDetail(data)}>
            <div className="d-h-start d-flex-2 w-unset ssm-100 mb-ssm-2">
                <span className="dsl-b14">{LibraryScoreCardsTabs.find((item) => item.id === index)?.label}</span>
            </div>
            <div className="d-h-start d-flex-5 w-unset ssm-100 mb-ssm-2">
                <span className="dsl-b14">{data ? data.title : 'Not Assigned'}</span>
            </div>
            <div className="d-h-start d-flex-2 w-unset ssm-100 mb-ssm-2">
                <span className="dsl-b14">{data ? data.quotas?.length : 'Not Assigned'}</span>
            </div>
            <div className="d-h-start d-flex-3 w-unset ssm-100 mb-ssm-2">
                <span className="dsl-b14">{data ? moment(data.due_at).format('MMM DD, YY') : 'Not Assigned'}</span>
            </div>
            <div className="d-h-start d-flex-4 w-unset ssm-100 mb-ssm-2">
                <span className="dsl-b14">{value ? value?.average_star_rating === 'N/A' ? 'Na' : <Rating score={value?.average_star_rating} /> : 'Not Assgined'}</span>
            </div>
            <div className="d-h-start d-flex-2 w-unset ssm-100 mb-ssm-2">
                <span className="dsl-b14">{data ? moment(data.updated_at).format('MMM DD, YY') : 'Not Assgined'}</span>
            </div>
            <div className="jc-end d-flex-1 w-unset ssm-100 mb-ssm-2">
                <EditDropdown options={options} onChange={(e) => changeHandler(e, data)} />
            </div>
        </div>
    );
};
const AssignmentsScoreCard = ({ role, onDetail, onSelectMenu }) => {
    const userId = useSelector((state) => state.app.id);
    const companyId = useSelector((state) => state.app.company_info.id);

    const scorecards = useSelector((state) => state.develop.instances.scorecards);

    const scorecardsAll = [...Array(4).keys()].map((key) => scorecards.data.find((scorecard) => scorecard.type === key));

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(DevelopActions.getlearnfeedsRequest(userId, 'scorecards'));
        dispatch(
            ManageActions.getperformancereviewsRequest(userId, {
                company_id: companyId,
                page: 1,
                per_page: 25,
                date_start: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
                date_end: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
            })
        );
    }, []);

    return (
        <div className="assignment-score-card">
            <div className="dsl-b18 bold mb-2">Scorecards</div>
            <ListHeader />
            {scorecardsAll?.map((item, index) => (
                <ScorecardItem data={item} role={role} index={index} onDetail={onDetail} onSelectMenu={onSelectMenu} />
            ))}
        </div>
    );
};

export default AssignmentsScoreCard;
